import { Box, GridItem } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { missingInformationAtom } from '../../../../recoil/atoms/missingInformationAtom';
import ContentMissingInformationForm from '../ContentMissingInformationForm';
import { useHippoText } from '../../../../hooks/useHippoText';

const ContentMissingInformation = (): React.JSX.Element => {
    const getHippoText = useHippoText();
    const missingInformation = useRecoilValue(missingInformationAtom);
    const { contentCohousing, contentCoinsured } = missingInformation;

    if (!contentCoinsured && !contentCohousing) return <></>;

    return (
        <>
            <GridItem span={12}>
                <Box>
                    <h6>Indboforsikring</h6>
                    {contentCoinsured && (
                        <>
                            <h6>{getHippoText('DSS-CON-MISSING-INFORMATION-CO-INSURED')}</h6>
                            {contentCoinsured.map((person) => (
                                <div key={`contentCoinsured-${String(person.fixedId)}`}>
                                    <ContentMissingInformationForm
                                        contentMissingDTO={person}
                                        flavourMissingName="contentCoinsured"
                                    />
                                </div>
                            ))}{' '}
                        </>
                    )}
                    {contentCohousing && (
                        <>
                            <h6>{getHippoText('DSS-CON-MISSING-INFORMATION-COHOUSING')}</h6>
                            <div id="contentCohousing-missing-information">
                                {contentCohousing.map((person) => (
                                    <div key={`contentCohousing-${String(person.fixedId)}`}>
                                        <ContentMissingInformationForm
                                            contentMissingDTO={person}
                                            flavourMissingName="contentCohousing"
                                        />
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </Box>
            </GridItem>
        </>
    );
};

export default ContentMissingInformation;
